import React from 'react';

import * as S from './SegmentSliderHotelCardLoader.styles';

const SegmentSliderHotelCardLoader = () => (
  <>
    <S.SegmentSliderLoader>
      <S.BannerSliderLoader></S.BannerSliderLoader>
      <S.SliderContentOuterWrap>
        <S.SliderContentInnerWrap>
          <S.SliderRatingLoader></S.SliderRatingLoader>
          <S.SliderAddressLoader></S.SliderAddressLoader>
          <S.SliderreviewsLoader></S.SliderreviewsLoader>
        </S.SliderContentInnerWrap>
        <S.SliderContentInnerWrap>
          <S.SliderPriceLoader></S.SliderPriceLoader>
          <S.SliderOfferLoader></S.SliderOfferLoader>
        </S.SliderContentInnerWrap>
      </S.SliderContentOuterWrap>
    </S.SegmentSliderLoader>
    <S.SegmentSliderLoader>
      <S.BannerSliderLoader></S.BannerSliderLoader>
      <S.SliderContentOuterWrap>
        <S.SliderContentInnerWrap>
          <S.SliderRatingLoader></S.SliderRatingLoader>
          <S.SliderAddressLoader></S.SliderAddressLoader>
          <S.SliderreviewsLoader></S.SliderreviewsLoader>
        </S.SliderContentInnerWrap>
        <S.SliderContentInnerWrap>
          <S.SliderPriceLoader></S.SliderPriceLoader>
          <S.SliderOfferLoader></S.SliderOfferLoader>
        </S.SliderContentInnerWrap>
      </S.SliderContentOuterWrap>
    </S.SegmentSliderLoader>
    <S.SegmentSliderLoader>
      <S.BannerSliderLoader></S.BannerSliderLoader>
      <S.SliderContentOuterWrap>
        <S.SliderContentInnerWrap>
          <S.SliderRatingLoader></S.SliderRatingLoader>
          <S.SliderAddressLoader></S.SliderAddressLoader>
          <S.SliderreviewsLoader></S.SliderreviewsLoader>
        </S.SliderContentInnerWrap>
        <S.SliderContentInnerWrap>
          <S.SliderPriceLoader></S.SliderPriceLoader>
          <S.SliderOfferLoader></S.SliderOfferLoader>
        </S.SliderContentInnerWrap>
      </S.SliderContentOuterWrap>
    </S.SegmentSliderLoader>
  </>
);

export default SegmentSliderHotelCardLoader;
